import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[iccTemplate]'
})
export class TemplateDirective {

  @Input() type = '';
    
  @Input('iccTemplate') name = '';
  
  constructor(public template: TemplateRef<any>) {}
  
  getType(): string {
      return this.name;
  }

}
